export class LocalStorageUtil {
  public static saveInStorage(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public static getFromStorage(key: string): unknown {
    return JSON.parse(localStorage.getItem(key));
  }

  public static removeFromStorage(key: string): void {
    localStorage.removeItem(key);
  }
}
